var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Body',{staticClass:"hero is-bold"},[_c('div',{staticClass:"hero-body",class:{'load-back': _vm.user!={}},staticStyle:{"padding":"0 !important"}},[_c('ClientMainMenu',{attrs:{"PCTRLLOG":_vm.CTRLLOG}}),_vm._v(" "),(_vm.user!={}&&!_vm.isCBLoading&&!_vm.sitemapFlug)?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.user==={}||_vm.isCBLoading||_vm.sitemapFlug)?_c('Loading'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9b514fe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/ClientBody.vue
// module id = null
// module chunks = 